module.exports = __webpack_public_path__ + "static/media/16.38e005c1.jpg";